const styles = (theme) => ({
  container: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
  },
  containerTitulo: {
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
  },
  containerTabs: {
    width: "83%",
    height: "500px",
  },

  containerTab: {
    width: "100%",
    display: "flex",
  },
  paper: {
    alignItems: "center",
    width: "100%",
    padding: "20px",
    justifyContent: "center",
    backgroundColor: theme.palette.mode === "dark" && "transparent",
  },
  containerForm: {
    width: "170px",
  },
  searchField: {
    width: "100%",
    maxWidth: 500,
    display: "flex",
    fontSize: "0.90rem", // diminui fonte geral

    "@media (max-width: 1349px)": {
      width: "100%",
    },
  },
  contentContainer: { display: "flex", flexDirection: "column", gap: 1 },
});

export default styles;
